import { render, staticRenderFns } from "./AddClientGroup.vue?vue&type=template&id=21307993&"
import script from "./AddClientGroup.vue?vue&type=script&lang=js&"
export * from "./AddClientGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports